var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26732 12.6666L3.33398 11.7333L7.06732 7.99992L3.33398 4.26659L4.26732 3.33325L8.00065 7.06659L11.734 3.33325L12.6673 4.26659L8.93398 7.99992L12.6673 11.7333L11.734 12.6666L8.00065 8.93325L4.26732 12.6666Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseX);
export default __webpack_public_path__ + "static/media/icon-close-x.64bc5889a5e29873b3d9fb713cee4d54.svg";
export { ForwardRef as ReactComponent };